/**
 * @param {object} args
 * @param {any} args.parsedJson
 * @returns {string}
 */
export function parseDetailErrorV2({ parsedJson }) {
  const detail = parsedJson?.errors?.[0]?.detail;
  const legacyDetail = parsedJson?.message;
  return detail ?? legacyDetail;
}
